import { useLocation } from 'hooks'
import { DropdownLink } from './styles'

/**
 * 
 * @param {String} children Text link to show
 * @param {Boolean} isLight Define if the theme is light (creators) or dark (home)
 * @param {Boolean} isNewTab Define if the link will be open in a new tab or not
 * @param {String} to URL to open
 * @param {Function} onClick Use it as a button passing a function
 * @param {String} color Define a specific color for the text
 * 
 * @returns A link/button to use in composition with AvatarDropdown
 */
const AvatarDropdownItem = ({
  children,
  isNewTab,
  to,
  onClick,
  color,
  icon: Icon,
  isFocused
}) => {

  const { isCreators } = useLocation()

  const newTabProps = isNewTab
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {}

  if (onClick) {
    return (
      <DropdownLink
        as='button'
        onClick={onClick}
        color={color}
        $isCreators={isCreators}
        $isFocused={isFocused}
      >
        {Icon && <Icon />}
        {children}
      </DropdownLink>
    )
  }

  return (
    <DropdownLink
      to={to}
      color={color}
      {...newTabProps}
      $isCreators={isCreators}
      $isFocused={isFocused}
    >
      {Icon && <Icon />}
      {children}
    </DropdownLink>
  )
}

export default AvatarDropdownItem